import logoUrl from './logo.jpeg';

const Logo = ({ className }: { className?: string }) => {
  return (
    <img
      src={logoUrl}
      alt="KTM Vape"
      className={className ?? 'w-full h-auto'}
    />
  );
};

export default Logo;
